import { useTxContext } from '../TxContext';

export function TxFooter() {
  const { transaction } = useTxContext();

  const netFlow = transaction.netFlow;

  // Don't render anything if netFlow is not provided (standalone transaction view)
  if (netFlow === undefined || netFlow === null) {
    return null;
  }

  const formattedNetFlow = `${netFlow > 0 ? '+' : ''}${netFlow}`;

  return (
    <div className="flex justify-end border-t border-gray-200 p-4">
      <div
        className={`rounded-md px-3 py-1.5 text-sm font-medium ${
          netFlow < 0 ? 'bg-red-50 text-red-600' : 'bg-green-50 text-green-600'
        }`}
      >
        {formattedNetFlow}
      </div>
    </div>
  );
}
